import React    from 'react';
import MuiDivider  from '@material-ui/core/Divider';

/**
 * This is just a passthrough class, so the application can use this library rather than material-ui directly
 */ 
export default function Divider(props) {
    return (<MuiDivider {...props} />)
}